module.exports = __webpack_public_path__ + "media/images/landing_page/kazu_vizija-09e9551971e5ce2e11c5ec8a0aafec33.webp";